import { ApiEndpointBuilder } from "@/services/api/types";
import { CurrentPlanDetails } from "../types";

interface GetCurrentPlanArgs {
  tenantId?: string; // optional tenant ID
}

const getCurrentPlan = (builder: ApiEndpointBuilder) => {
  return builder.query<CurrentPlanDetails, GetCurrentPlanArgs | void>({
    query: (args) => {
      const headers: Record<string, string> = {};
      if (args?.tenantId) {
        headers["x-tenant"] = args.tenantId;
      }

      return {
        url: `/checkout/subscription`,
        method: "GET",
        headers,
      };
    },
    providesTags: ["currentPlanCheckout"],
    transformResponse: (res: CurrentPlanDetails) => {
      res.items = res.items.filter(item => item.quantity > 0);
      return res;
    },
  });
};
export default getCurrentPlan;
